import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';

// HuPath v2 design tokens
const HT = {
  yellow: '#FFD166', yellowBg: '#FFF8E7', yellowShadow: '#E0B554',
  green: '#88C057', greenDark: '#5E9E3E', greenBg: '#E8F3D9',
  coral: '#FF8C42', coralDark: '#E76F51', coralPress: '#B8431E',
  text: '#2D2D2D', textSoft: '#6B6B6B', textMuted: '#9A9A9A',
  border: '#E8E0CC', white: '#FFFFFF', teal: '#5AC0B5',
};
const FONT_BODY = '"Nunito", "Baloo 2", sans-serif';
const SHADOW_SM = '0 2px 6px rgba(139,111,71,0.08)';

const BottomMenu = ({ onPrev, onNext, onToggleHint, onFillHint, showHint, isReviewMode, hideHint, currentIndex = 0, totalCount = 1 }) => {
  const { t } = useLanguage();
  const prevDisabled = currentIndex === 0;
  return (
    <div
      className="flex items-center justify-between w-full px-4 md:px-6 h-full"
      style={{ fontFamily: FONT_BODY, color: HT.text }}
    >
      {/* Previous Button */}
      <button
        onClick={onPrev}
        disabled={prevDisabled}
        style={{
          padding: '8px 16px', borderRadius: 999,
          border: `1px solid ${HT.border}`,
          background: prevDisabled ? HT.greenBg : HT.white,
          boxShadow: prevDisabled ? 'none' : SHADOW_SM,
          color: prevDisabled ? HT.textMuted : HT.text,
          fontFamily: FONT_BODY, fontSize: 13, fontWeight: 800,
          cursor: prevDisabled ? 'default' : 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          letterSpacing: 0.3,
        }}
      >
        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>arrow_back</span>
        <span className="hidden md:inline">{t('previous')}</span>
      </button>

      {/* Dot Pagination */}
      <div className="flex items-center gap-2 flex-wrap justify-center" style={{ maxWidth: '60%' }}>
        {Array.from({ length: totalCount }).map((_, i) => {
          const isCurrent = i === currentIndex;
          const isPast = i < currentIndex;
          return (
            <div
              key={i}
              style={{
                width: isCurrent ? 14 : 10,
                height: isCurrent ? 14 : 10,
                borderRadius: '50%',
                background: isCurrent ? HT.coralDark : isPast ? HT.teal : HT.greenBg,
                border: isCurrent ? 'none' : `1px solid ${HT.border}`,
                boxShadow: isCurrent ? SHADOW_SM : 'none',
                transition: 'all 0.2s',
              }}
            />
          );
        })}
      </div>

      {/* Next Button */}
      <button
        onClick={onNext}
        style={{
          padding: '10px 22px', borderRadius: 999,
          border: 'none',
          background: HT.coralDark, color: HT.white,
          boxShadow: `0 4px 0 ${HT.coralPress}`,
          fontFamily: FONT_BODY, fontSize: 14, fontWeight: 800,
          cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          letterSpacing: 0.3,
          whiteSpace: 'nowrap',
        }}
      >
        <span>{t('next')}</span>
        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>arrow_forward</span>
      </button>
    </div>
  );
};

export default BottomMenu;
